import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import plus from '../assets/img/plusOrange.png';
import minus from '../assets/img/minus.png';

import "../assets/css/deposit.scss"

class AboutPopup extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedQuestion: this.props.selectedQuestion,
            active1: false,
            active2: false,
            active3: false,
            active4: false,
            active5: false,
            active6: false
        }
    }

    toggleClass1 = () => {
        this.setState({
            active1: !this.state.active1,
            active2: false,
            active3: false,
            active4: false,
            active5: false,
            active6: false,
        });
    }

    toggleClass2 = () => {
        this.setState({
            active1: false,
            active2: !this.state.active2,
            active3: false,
            active4: false,
            active5: false,
            active6: false,
        });
    }

    toggleClass3 = () => {
        this.setState({
            active1: false,
            active2: false,
            active3: !this.state.active3,
            active4: false,
            active5: false,
            active6: false,
        });
    }

    toggleClass4 = () => {
        this.setState({
            active1: false,
            active2: false,
            active3: false,
            active4: !this.state.active4,
            active5: false,
            active6: false,
        });
    }

    toggleClass5 = () => {
        this.setState({
            active1: false,
            active2: false,
            active3: false,
            active4: false,
            active5: !this.state.active5,
            active6: false,
        });
    }

    toggleClass6 = () => {
        this.setState({
            active1: false,
            active2: false,
            active3: false,
            active4: false,
            active5: false,
            active6: !this.state.active6,
        });
    }

    setQuestion = (e) => {
        this.setState({
            selectedQuestion: e.currentTarget.value
        })
    }

    render() {
        const { t } = this.props;
        const classAbout = this.props.displayAbout === true ? ["moreFrame"] : ["hidden"];
        const classQuestion1 = this.state.active1 === true ? ["qOpen"] : ["q"];
        const classQuestion2 = this.state.active2 === true ? ["qOpen"] : ["q"];
        const classQuestion4 = this.state.active4 === true ? ["qOpen"] : ["q"];
        const classQuestion5 = this.state.active5 === true ? ["qOpen"] : ["q"];
        const classQuestion6 = this.state.active6 === true ? ["qOpen"] : ["q"];

        return (
            <div className={classAbout}>
                <div className="moreBox">
                    <div><span className="grey_pill bigHide">{t("general.hide")}<img src={minus} alt="minus" /></span></div>
                    <div className="moreHead">
                        <h3>{t("about.title")}</h3>
                    </div>
                    <div className="moreQ">
                        <div className="moreQHead">
                            <span className="blue_pill">{t("about.anyQuestion")}</span>
                        </div>
                        <div className="moreQContent">
                            <div className="row">
                                <div className={classQuestion1} onClick={e => this.toggleClass1()}>
                                    <div className="blockQuestion">
                                        <span>&nbsp;</span>
                                        <span>{t("about.howSafe")}</span>
                                    </div>
                                    <div>
                                        <p>{t("about.answerHowSafe1")}</p>
                                        <p>{t("about.answerHowSafe2")}</p>
                                    </div>
                                </div>
                                <div className={classQuestion2} onClick={e => this.toggleClass2()}>
                                    <div className="blockQuestion">
                                        <span>&nbsp;</span>
                                        <span>{t("about.howGetPass")}</span>
                                    </div>
                                    <div>
                                        <p>{t("about.answerHowGetPass")}</p>
                                        <p>{t("about.answerHowGetPass2")}</p>
                                    </div>
                                </div>
                                {/*<div className={classQuestion3} onClick={e => this.toggleClass3()}>
                                    <div className="blockQuestion">
                                        <span>&nbsp;</span>
                                        <span>{t("about.WTDNoToken")}</span>
                                    </div>
                                    <div>
                                        <p>{t("about.answerWTDNoToken")}</p>
                                    </div>
                                </div>*/}
                                <div className={classQuestion4} onClick={e => this.toggleClass4()}>
                                    <div className="blockQuestion">
                                        <span>&nbsp;</span>
                                        <span>{t("about.unavailableFile")}</span>
                                    </div>
                                    <div>
                                        <p>{t("about.answerUnavailableFile")}</p>
                                        <ul>
                                            <li>{t("about.answerUnavailableFileReason1")}</li>
                                            <li>{t("about.answerUnavailableFileReason2")}</li>
                                            <li>{t("about.answerUnavailableFileReason3")}</li>
                                        </ul>
                                        <p>{t("about.answerUnavailableFileEnd")}</p>
                                    </div>
                                </div>
                                <div className={classQuestion5} onClick={e => this.toggleClass5()}>
                                    <div className="blockQuestion">
                                        <span>&nbsp;</span>
                                        <span>{t("about.whichBrowser")}</span>
                                    </div>
                                    <div>
                                        <p>{t("about.whichBrowserAnswer")}</p>
                                        <p><u>{t("about.whichBrowserAnswer2")}</u><br />
                                            - Chrome (Version > 70)<br />
                                            - Firefox (Version > 65)<br />
                                            - Firefox ESR (Version > 60)<br />
                                            - Safari (Version > 11)<br />
                                            - Opera (Version > 60)<br />
                                            - Chromium (Version > 75)<br />
                                            - IE (Version > 10)<br />
                                            - Edge (Version > 44)<br /></p>
                                        <p><u>{t("about.whichBrowserAnswer3")}</u><br />
                                            - Android </p>
                                    </div>
                                </div>
                                <div className={classQuestion6} onClick={e => this.toggleClass6()}>
                                    <div className="blockQuestion">
                                        <span>&nbsp;</span>
                                        <span>{t("about.meToo")}</span>
                                    </div>
                                    <div>
                                        <p>{t("about.answerMeToo1")}<a href={"mailto:contact@lockself.com"}>contact@lockself.com</a></p>
                                        <p>{t("about.answerMeToo2")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="moreWho">
                        <span className="grey_pill">{t("about.who")}</span>
                        <p>{t("about.answerWho")}</p>
                        <a href="https://www.lockself.com/" target="_blank" rel="noopener noreferrer"><button>{t("general.more")} <img src={plus} alt="plus" /></button></a>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(AboutPopup)
